import API from '@/lib/api'
import Cookie from 'js-cookie'
import JWT from 'jsonwebtoken'
import moment from 'moment'
import APIRefreshTokenInterceptor from '@/lib/api/APIRefreshTokenInterceptor.js'

const authModule = {
  state: {
    token: null,
    tokenInfo: null
  },
  mutations: {
    SET_TOKEN(state, newVal) {
      state.token = newVal
      if(state.token === null) {
        state.tokenInfo = null
        return
      }
      const token = JWT.decode(state.token)
      const tokenInfo = {
        headers: {
          expires: moment(token.exp * 1000)
        },
        payload: token.data
      }

      state.tokenInfo = tokenInfo
    },
    UNSET_AUTH(state, newVal) {

    }
  },
  getters: {
    hasToken (state) {
      return state.token != null
    },
    refreshToken () {
      return Cookie.get('auth.refreshToken') || null
    },
    tokenIsAboutToExpire (state) {
      if(!state.tokenInfo) return null
      return (
              state.tokenInfo.headers.expires.isAfter(moment()) &&
              moment().add(1, 'h').isAfter(state.tokenInfo.headers.expires)
            )
    },
    tokenExpired (state) {
      if(!state.tokenInfo) return null
      return moment().isAfter(state.tokenInfo.headers.expires)
    }
  },
  actions: {
    async init ({dispatch, commit}) {
      if(Cookie.get('auth.token')) {
        commit('SET_TOKEN', Cookie.get('auth.token'))
      }
    },
    async LOGIN ({ commit, dispatch, getters }, { email, password } = {}) {
      let resp = await API.post('/auth', { email, password })

      if(resp.status == 200) {
        Cookie.set('auth.token', resp.data.token)
        Cookie.set('auth.refreshToken', resp.data.refreshToken)

        commit('SET_TOKEN', resp.data.token)

        API.interceptors.response.use(response => { return response }, APIRefreshTokenInterceptor)
        API.defaults.headers.common.Authorization = getters.hasToken
          ? 'Bearer ' + state.token
          : ''

        return true
      } else {
        return false
      }
    },
    async LOGOUT ({commit}) {
      Cookie.remove('auth.token')
      Cookie.remove('auth.refreshToken')

      commit('SET_TOKEN', null)
      //Remove refresh token from server
    },
    async VALIDATE ({state, commit, getters}) {
      if(getters.hasToken) {
        console.log(getters.tokenIsAboutToExpire, getters.tokenExpired)
        if(getters.tokenIsAboutToExpire || getters.tokenExpired) {
          try {
            const newToken = await API.post('/auth/refresh', {refreshToken: getters.refreshToken})
            console.log(newToken)
            Cookie.set('auth.token', newToken.data.token)
            commit('SET_TOKEN', newToken.data.token)
          } catch (error) {
            commit('UNSET_AUTH')
            Cookie.remove('auth.token')
            Cookie.remove('auth.refreshToken')
            return false
          }
        }

        API.interceptors.response.use(response => {return response}, APIRefreshTokenInterceptor)
        API.defaults.headers.common.Authorization = getters.hasToken
          ? 'Bearer ' + state.token
          : ''
      }
    }
  }
}

export const state = authModule.state
export const getters = authModule.getters
export const mutations = authModule.mutations
export const actions = authModule.actions

/*export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  jwtData: (state, getters) => state.currentUser.token ? JSON.parse(atob(state.currentUser.token.split('.')[1])) : null,
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  async attempt({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    let resp = await API.post('/auth', { email, password })

    if(resp.status == 200) {
      const user = resp.data;
      commit('SET_CURRENT_USER', user)
      return user
    } else {
      return resp
    }
  },

  // Logs out the current user.
  logout({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  async validate({ commit, state }) {
    console.log("validate token")
    /*let resp = await API.post('/auth/refresh', {refreshToken: state.currentUser.refreshToken});
    if(resp.status == 400) {
      dispatch('logout')
    }
    else {
      const user = resp.data;
      commit('SET_CURRENT_USER', user)
      return user
    }*/

    /*if (!state.currentUser) return Promise.resolve(null)

    return API
      .get('/api/session')
      .then(response => {
        const user = response.data
        commit('SET_CURRENT_USER', user)
        return user
      })
      .catch(error => {
        if (error.response.status === 401) {
          commit('SET_CURRENT_USER', null)
        }
        return null
      })*/
//  },
//}

// ===
// Private helpers
// ===

/*function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  API.defaults.headers.common.Authorization = state.currentUser
    ? 'Bearer ' + state.currentUser.token
    : ''
}*/



// WEBPACK FOOTER //
// ./src/state/modules/auth.js